import React from 'react';
import {Button, FormControl, InputLabel, MenuItem, OutlinedInput, Select, TextField,} from '@material-ui/core';
import Pagination from "@material-ui/lab/Pagination";
import {withStyles} from '@material-ui/core/styles'

const styles = {
  paginationWrapper: {
    position:'sticky',
    left:'0px',
    paddingBottom:'1rem'
  },
  paginationContainer: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap:'0.5em',
    padding: '1em 0em',
    position:'static'
  },
  paginationGroup: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap:'0.5em',
    padding: '0em',
    alignItems: 'center',
    // flexGrow:1,
    // justifyContent:'space-between'
  },
  pageLabel: {
    flexShrink: 1,
    fontSize: '0.7225rem',
    fontWeight: 500,
    color: 'rgba(0,0,0,0.7225)',
    // minWidth: '7.5em',
    whiteSpace:'nowrap',
    textAlign:'center'
  },
  pageControl: {
    margin: '0 auto',
    '& ul':{
      gap:'0.15em 0',
    },
    '& ul > li > button':{
      borderRadius:'0px',
      margin:'0px',
      marginLeft:'-1px',
      width: '28px',
      height: '28px',
      backgroundColor: '#ffffff'
    },
    '& ul > li:first-child > button':{
      borderRadius:'4px 0 0 4px',
      margin:'0px'
    },
    '& ul > li:last-child > button':{
      borderRadius:'0 4px 4px 0',
      borderWidth:'1px'
    },
    '& ul > li > div':{
      margin: '0',
      minWidth:'22px',
      width:'22px',
      boxSizing:'border-box'
    }
  },
  pageJumpControl: {
    // marginRight: 'auto',
    // flexGrow:1,
  },
  pageJumpInput: {
    width: '3.5em',
    backgroundColor: '#ffffff',
    '& div':{
      height: '28px',
      borderRadius: '4px 0 0 4px',
    }
  },
  pageJumpInputInner: {
    padding: '0.6em',
    fontSize: '0.7225em'
  },
  pageJumpButton: {
    marginLeft: '-1',
    borderLeft: 'none',
    borderRadius: '0 4px 4px 0',
    fontSize:'0.7225em',
    minWidth: 'unset',
    padding: '0.2em 0.4em',
    height: '28px',
    backgroundColor: '#ffffff'
  },
  rowsLabel: {
    marginRight: '1em',
    flexShrink: 0,
    fontSize: '0.7225rem',
    whiteSpace:'nowrap'
  },
  rowsSelect: {
  },


  pageSize:{
    // flexDirection:'row',
    // flexWrap:'wrap'
  },
  select:{
    boxSizing: 'content-box',
    height: '28px',
    // padding: '4px 0 0 0',
    // overflow:'hidden',
    fontSize: '0.85rem',
    fontWeight: 400,
    backgroundColor: '#ffffff',
    '& > div:first-child':{
      paddingLeft: '0.5rem',
      overflow:'hidden',
      borderRadius:'4px 0 0 4px',
      boxSizing:'border-box',
      minWidth:'5rem',
      height:'34px',
      textAlign: 'right'
    }
  },
  text:{
    margin: 0,
    textTransform: 'uppercase',
    fontSize: '0.7225rem',
    fontWeight: 500,
    whiteSpace:'nowrap',
    color:'rgba(0,0,0,0.54)',
  },
  filler:{maxWidth: '232px', minWidth:'0px', marginLeft: '-0.5em', flexShrink: 1, flexGrow: 232}
};

function DataPagination(props) {
  const {controller, itemsTotal, pageItemCount, handlePageChange, handlePageJump, handlePageJumpKeyDown, handleChangeRowsPerPage, classes} = props;

  const itemFirst = Math.max(0, ((controller.page - 1) * controller.rowsPerPage) + 1);
  const itemLast = Math.min(itemFirst + pageItemCount - 1, controller.page * controller.rowsPerPage );

  return (
    <div className={classes.paginationWrapper}>
      <div id="paginationFooter" className={classes.paginationContainer}>
        <div className={classes.paginationGroup}>
          <span className={classes.pageLabel}>
            {itemsTotal === 0 || !itemsTotal || !itemFirst ?
              <><span id="pageCount">{itemFirst}-{itemLast}</span><br/></> :
              <><span id="pageCount">{itemFirst}-{itemLast}</span><br/>of <span id="dataTotal">{itemsTotal}</span></>
            }
          </span>
          <FormControl className={classes.pageSize} variant="outlined">
            <InputLabel style={{flexShrink: 0, transform: 'translate(12px, -6px) scale(1)', fontSize: '0.7225rem'}}>
              Page Size:
            </InputLabel>
            <Select
              id="pageSize"
              className={classes.select}
              value={controller.rowsPerPage}
              onChange={handleChangeRowsPerPage}
              input={
                <OutlinedInput
                  margin='dense'
                  label="Page Size:"
                />}
            >
              {[2,12,24,60,96,120].map((size) => (
                <MenuItem key={size} value={size}>{size}</MenuItem>
              ))}
            </Select>
          </FormControl>
          <div className={classes.pageJumpControl}>
            <TextField
              id="pageJumpField"
              variant="outlined"
              shape="rounded"
              className={classes.pageJumpInput}
              size="small"
              label="Page"
              defaultValue={controller.page}
              onKeyDown={handlePageJumpKeyDown}
              InputProps={{
                classes: {
                  input: classes.pageJumpInputInner
                }
              }}
            />
            <Button
              id="pageJumpButton"
              className={classes.pageJumpButton}
              onClick={handlePageJump}
              variant="outlined"
            >
              Go
            </Button>
          </div>
        </div>
        <Pagination
          id="pageButtons"
          className={classes.pageControl}
          count={!!itemsTotal ? Math.ceil(itemsTotal / controller.rowsPerPage) : pageItemCount < controller.rowsPerPage ? controller.page : controller.page + 3}
          page={controller.page}
          siblingCount={2}
          boundaryCount={1}
          variant="outlined"
          shape="rounded"
          onChange={handlePageChange}
        />
        <div className={classes.filler} />
      </div>
    </div>
  );
}

export default withStyles(styles)(DataPagination)
